import { Platform } from 'react-native'

import { UseControllerProps } from 'react-hook-form'

import HideIcon from 'app/assets/icons/auth/hide.svg'
import ShowIcon from 'app/assets/icons/auth/show.svg'
import useBoolean from 'app/hooks/useBoolean'

import IconButton from '../base/IconButton'

import TextField, { TextFieldProps } from './TextField'

export interface PasswordFieldCustomProps {
  hideEncode?: boolean
  disableCopy?: boolean
}

export type PasswordFieldProps = PasswordFieldCustomProps &
  TextFieldProps &
  UseControllerProps

const PasswordField: RFC<PasswordFieldProps> = ({
  name,
  id,
  transform,
  hideEncode = false,
  disableCopy = true,
  ...rest
}) => {
  const [showPassword, setShowPassword] = useBoolean()

  const preventDefault = (e) => {
    if (e.preventDefault) {
      e.preventDefault()
    }
  }

  const disableCopyProps = disableCopy && {
    onCopy: preventDefault,
    onCut: preventDefault
  }

  return (
    <TextField
      name={name}
      id={id}
      transform={transform}
      {...rest}
      {...Platform.select({
        web: { type: showPassword ? 'text' : 'password' },
        native: { secureTextEntry: !showPassword }
      })}
      {...disableCopyProps}
      endAdornment={
        <IconButton
          {...Platform.select({
            web: {
              'aria-label': 'toggle password visibility',
              edge: 'end',
              onClick: setShowPassword.toggle
            },
            native: { onPress: setShowPassword.toggle }
          })}
        >
          {showPassword ? <ShowIcon /> : <HideIcon />}
        </IconButton>
      }
    />
  )
}

export default PasswordField
